import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import {
  GetOrchSurveyResponse,
  GetSurveySurveyCodeEnum,
  QineticSurveyApi,
} from "../../orchestrator-api-client";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const getCoherenceQuestionnaireData = createAsyncThunk<
  GetOrchSurveyResponse,
  { surveyCode: GetSurveySurveyCodeEnum; fiscalCode?: string },
  ThunkApi
>(
  "getCoherenceQuestionnaire",
  async ({ surveyCode, fiscalCode }, { rejectWithValue, getState }) => {
    try {
      if (!fiscalCode) {
        const {
          customer: { personalInfo },
        } = getState();
        fiscalCode = personalInfo.fiscalCode;
      }

      const { data } = await new QineticSurveyApi().getSurvey(
        fiscalCode,
        surveyCode,
      );

      return data;
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Salvataggio questionario coerenza cpi",
        description:
          "Non siamo riusciti a salvare le tue domande.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
